<template>
    <v-container grid-list-xs>
        <v-row>
            <v-col>
                <v-sheet class="mt-10 pa-5" elevation="3">
                    <h3 id="pay_monthly-decision-header" class="mb-2 primary--text">
                        {{ $t(`pay_monthly.decision.declined.header`) }}
                    </h3>
                    <div id="pay_monthly-decision-body" class="mb-4 mt-2">
                        {{ $t(`pay_monthly.decision.declined.body-1`) }}
                    </div>
                    <div class="mb-4">
                        {{ $t(`pay_monthly.decision.declined.body-2`) }}
                    </div>
                    <div id="result-container">
                        <div>
                            <div id="pay_monthly-app-title" class="primary-color">
                                {{ $t(`pay_monthly.decision.declined.app-title`) }}
                            </div>
                            <div id="pay_monthly-app-body" class="font-weight-bold">
                                {{ $t(`pay_monthly.decision.declined.app-body`) }}
                            </div>
                            <div v-if="applyResponse" id="pay_monthly-app-number" class="primary-color">
                                #{{ applyResponse.applicationId }}
                            </div>
                        </div>
                    </div>
                </v-sheet>
            </v-col>
        </v-row>
    </v-container>
</template>

<script lang="ts">
    import { defineComponent } from "vue"
    import AutoFinishMixin from "@/components/apply/AutoFinishMixin"
    import { providerState } from "@/state"

    export default defineComponent({
        mixins: [AutoFinishMixin],

        data() {
            return {
                applyResponse: providerState.applyResponse,
                submitting: false,
            }
        },

    })
</script>

<style lang="scss" scoped>
    #pay_monthly-app-number {
        font-size: 26px;
        font-weight: 700;
    }

    #pay_monthly-app-title {
        font-size: 16px;
        line-height: 24px;
        font-weight: 700;
    }

    #pay_monthly-app-body {
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
    }
    .pay_monthly-app-number {
        font-size: 26px;
        font-weight: 700;
    }
</style>
